query MobileSdkFilterOptions($limit: Int = 1000) {
	msdk_report_runs(limit: $limit, group: [app, app_version, sdk_type, product_version]) {
		app
		app_version
		sdk_type
		product_version
	}
}
